var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about container"},[(_vm.banner)?_c('page-header',{attrs:{"color":"white","type":"image","image":_vm.banner,"height":1080}}):_vm._e(),_c('div',{staticClass:"mainbox",domProps:{"innerHTML":_vm._s(_vm.page_content)}}),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }